/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Findprospectsfromsalesforce_Selectedprospects5Inputs */

const en_coinvestments_findprospectsfromsalesforce_selectedprospects5 = /** @type {(inputs: Coinvestments_Findprospectsfromsalesforce_Selectedprospects5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected prospects`)
};

/**
* | output |
* | --- |
* | "Selected prospects" |
*
* @param {Coinvestments_Findprospectsfromsalesforce_Selectedprospects5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_findprospectsfromsalesforce_selectedprospects5 = /** @type {((inputs?: Coinvestments_Findprospectsfromsalesforce_Selectedprospects5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Findprospectsfromsalesforce_Selectedprospects5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_findprospectsfromsalesforce_selectedprospects5(inputs)
});
export { coinvestments_findprospectsfromsalesforce_selectedprospects5 as "coInvestments_findProspectsFromSalesforce_selectedProspects" }